import React, { useState, useEffect } from 'react'
import { Form, InputNumber, Switch, Space, TimePicker } from 'antd';
import moment from 'moment';

import SPTimeRangePicker from '../../../base/SPTimeRangePicker';
interface props {
    onChange?: any,
    value?: any,
    enums?: any
}

const SPBusinessTime: React.FC<props> = (props) => {
  const { onChange, value, enums } = props;

  const [formData, setFormData] = useState({});

  

  const form = Form.useFormInstance();
  useEffect(() => {
    if (!value) {
      // const defaultFormData = { startTime: moment('08:00', 'HH:mm'), endTime: moment('21:00', 'HH:mm') }, unit: false }
      form.setFieldsValue({ business: { time: [moment('08:00', 'HH:mm'), moment('21:00', 'HH:mm')] } })
    }
    if (value) {
      form.setFieldsValue(value);
    }
  }
  , [])

  return (
    <>
      <Space>
        <Form.Item
          name={['business', 'time']}
          noStyle
          rules={[
            {
              required: true,
              message: '请选择营业时间'
            }
          ]}
        >
          <TimePicker.RangePicker format="HH:mm" />
          {/* <SPTimeRangePicker startName="startTime" endName="endTime" /> */}
        </Form.Item>
        <Form.Item
          name={['business', 'openNightService']}
          noStyle
          valuePropName='checked'
        >
          <Switch />
        </Form.Item>
        收取夜间取/还车服务费
      </Space>
      {form.getFieldValue(['business', 'openNightService']) &&
        <div style={{ backgroundColor:'#F5F6FA', padding: '16px', marginTop: '12px', borderRadius: '6px' }}>
          <Space>
            用户在21:00（不包含）后～8:00（不包含）前，
          </Space>
          <Space>
            取车收取
            <Form.Item
              name={['business', 'pickUpFee']}
              noStyle
              rules={[
                {
                  required: true,
                  message: '请输入取车服务费'
                }
              ]}
            >
              <InputNumber width={150} step={1} precision={0} min={0} max={100} />
            </Form.Item>
            元/次，
            还车收取
            <Form.Item
              name={['business', 'returnFee']}
              noStyle
              rules={[
                {
                  required: true,
                  message: '请输入还车服务费'
                }
              ]}
            >
              <InputNumber width={150} step={1} precision={0} min={0} max={100} />
            </Form.Item>
            元/次
          </Space>
        </div>
      }
    </>
  )
}

export default SPBusinessTime
